export default {"src":"/_next/static/media/raisin.76b30bfa.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};